import { useTranslation } from 'react-i18next'

import styles from './Requisites.module.scss'

export default function Requisites () {
  const { t: tc } = useTranslation('contacts')

  const copyRequisites = () => {
    const requisites = [
      `${tc('requisites.name')}: ${tc('requisites.nameValue')}`,
      `${tc('requisites.director')}: ${tc('requisites.directorValue')}`,
      `${tc('requisites.address')}: ${tc('requisites.addressValue')}`,
      `${tc('requisites.bin')}: ${tc('requisites.binValue')}`,
      `${tc('requisites.iik')}: ${tc('requisites.iikValue')}`,
      `${tc('requisites.bank')}`,
      `${tc('requisites.bic')}: ${tc('requisites.bicValue')}`,
      `${tc('requisites.reception')}: ${tc('requisites.receptionValue')}`,
      `${tc('requisites.accounting')}: ${tc('requisites.accountingValue')}`,
      `${tc('requisites.accountingFax')}`,
      `${tc('requisites.sales')}: ${tc('requisites.salesValue')}`,
    ].join('\n')

    navigator.clipboard.writeText(requisites)
  }

  return (
    <section className={styles.requisites}>
      <div className={styles.requisites__header}>
        <h2 className={styles.requisites__title}>
          {tc('requisites.title')}
        </h2>
        <button
          type="button"
          onClick={copyRequisites}
          className={styles.requisites__copyButton}
        >
          {tc('requisites.copyAll')}
        </button>
      </div>

      <div className={styles.requisites__content}>
        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.name')}
          </p>
          <p className={styles.requisites__value}>
            {tc('requisites.nameValue')}
          </p>
        </div>

        <div className={styles.requisites__item}>
          <div className={styles.requisites__labelGroup}>
            <p className={styles.requisites__label}>
              {tc('requisites.director')}
            </p>
            <p className={styles.requisites__labelNote}>
              {tc('requisites.directorNote')}
            </p>
          </div>
          <p className={styles.requisites__value}>
            {tc('requisites.directorValue')}
          </p>
        </div>

        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.address')}
          </p>
          <p className={styles.requisites__value}>
            {tc('requisites.addressValue')}
          </p>
        </div>

        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.bin')}
          </p>
          <p className={styles.requisites__value}>
            {tc('requisites.binValue')}
          </p>
        </div>

        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.iik')}
          </p>
          <p className={styles.requisites__value}>
            {tc('requisites.iikValue')}
          </p>
        </div>

        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.bank')}
          </p>
        </div>

        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.bic')}
          </p>
          <p className={styles.requisites__value}>
            {tc('requisites.bicValue')}
          </p>
        </div>

        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.reception')}
          </p>
          <p className={styles.requisites__value}>
            {tc('requisites.receptionValue')}
          </p>
        </div>

        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.accounting')}
          </p>
          <div className={styles.requisites__valueGroup}>
            <p className={styles.requisites__value}>
              {tc('requisites.accountingValue')}
            </p>
            <p className={styles.requisites__value}>
              {tc('requisites.accountingFax')}
            </p>
          </div>
        </div>

        <div className={styles.requisites__item}>
          <p className={styles.requisites__label}>
            {tc('requisites.sales')}
          </p>
          <p className={styles.requisites__value}>
            {tc('requisites.salesValue')}
          </p>
        </div>
      </div>
    </section>
  )
}
